import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getGeneralButtonStyle = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  box-shadow: none;
  font-family: ${({ theme }) => theme.font.typography.bodyText.fontFamily};
  font-weight: ${({ theme }) => theme.font.typography.bodyText.fontWeight.regular};
  border-radius: 4px;
  align-items: center;

  // FOCUS
  &&& {
    .ant-btn-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    :focus-visible {
    outline: 1px solid;
  }}
`;
